import { AppType } from '../../constants/AppType';
import Applications from '../../components/Applications/Applications';
import withHasPermission from '../../hoc/withHasPermission';
import { Permission } from '../../permissions/permission';

export const WebSites = withHasPermission(() => {
    return <Applications type={AppType.WebSite} title={'Web Sites'} icon={'fa fa-sitemap'} />;
}, Permission.Root_WebSites);
